import apiClient from '../http/apiClient';

export default class CategoryApiService {
    static list = () => apiClient.get('/category');
}
